 import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getFirestore, Firestore, enableIndexedDbPersistence, onSnapshot, doc } from 'firebase/firestore';
import { getAuth, Auth, signInAnonymously, AuthError } from 'firebase/auth';
import { getAnalytics, Analytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyAzgzHMyHif6s0ls5mgNerF_u5yJi1zu5w",
  authDomain: "sales-presentation-cf9a9.firebaseapp.com",
  projectId: "sales-presentation-cf9a9",
  storageBucket: "sales-presentation-cf9a9.firebasestorage.app",
  messagingSenderId: "104149906972",
  appId: "1:104149906972:web:80b8e7b8e3f516be5711d9",
  measurementId: "G-52Y398L21T"
};

let app: FirebaseApp;
let db: Firestore;
let auth: Auth;
let analytics: Analytics | null = null;

const initializeFirebase = async () => {
  try {
    // Initialize Firebase if it hasn't been initialized yet
    if (!getApps().length) {
      app = initializeApp(firebaseConfig);
      console.log('Firebase initialized successfully');
    } else {
      app = getApps()[0];
      console.log('Using existing Firebase instance');
    }

    // Initialize Auth first
    auth = getAuth(app);
    console.log('Auth initialized successfully');

    // Initialize Firestore before attempting auth
    db = getFirestore(app);
    console.log('Firestore initialized successfully');

    // Enable offline persistence
    try {
      await enableIndexedDbPersistence(db);
      console.log('Offline persistence enabled');
    } catch (error: any) {
      if (error?.code === 'failed-precondition') {
        console.warn('Multiple tabs open, persistence can only be enabled in one tab at a time.');
      } else if (error?.code === 'unimplemented') {
        console.warn('The current browser does not support persistence.');
      } else {
        console.warn('Error enabling offline persistence:', error);
      }
    }

    // Try anonymous sign in
    try {
      await signInAnonymously(auth);
      console.log('Anonymous auth successful');
    } catch (authError: any) {
      if (authError?.code === 'auth/configuration-not-found') {
        console.warn('Anonymous authentication is not enabled in Firebase Console');
      } else {
        console.error('Anonymous auth failed:', authError);
      }
      // Continue without authentication
      console.log('Continuing without authentication');
    }

    // Only initialize analytics in production and in browser environment
    if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined') {
      try {
        analytics = getAnalytics(app);
        console.log('Analytics initialized successfully');
      } catch (error) {
        console.warn('Analytics initialization failed:', error);
      }
    }
  } catch (error) {
    console.error('Firebase initialization error:', error);
    throw error;
  }
};

// Initialize Firebase immediately
initializeFirebase().catch(console.error);

export { app, db, auth, analytics };
export { onSnapshot, doc } from 'firebase/firestore';
